import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { Mixpanel } from '../../../../config/Mixpanel'
import constants from '../../../../utilities/constants'

const FaqAccordion = ({title, content, index, length, points}) => {
      const [isActive, setIsActive] = useState(false);
   return (
          <>
              <div key={index} className={` bg-[#406aff26] ${isActive === false ? "flex flex-col cursor-pointer justify-center font-semibold" : "flex flex-col justify-center "} ${index !== length-1 && 'border-b-[1px] border-b-white/30'}   px-5 py-4 w-full ${index === 0 ? 'rounded-t-lg' : index === length - 1 ? 'rounded-b-lg' : ''} `} >
                  <div className="flex flex-row justify-between items-center w-full" onClick={(event) => {
                    // Track FAQ click
                    Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_FAQ_OPENED, {
                      faqIndex: index,
                      faqTitle: title,
                      isOpening: !isActive
                    })
                    
                    setIsActive(!isActive)
                  }}>
                      <div className="text-[16px] font-medium leading-5 tracking-wide text-white text-left cursor-pointer md:text-[18px] ">
                      {title}
                      </div>
                      <FontAwesomeIcon icon={isActive ? faAngleDown :faAngleRight} className="tracking-widest text-xl text-[#7FC241] pl-2" />
                  </div>
                  {isActive && <div className="mt-4 text-sm md:text-[16px] text-left font-normal pb-2 text-white">
                    {content}
                    </div>}
                  {isActive && points && <ul className="ml-5 text-sm font-light list-disc list-outside">
                      {points.map((item, itemIndex) => (
                          <li key={itemIndex}>{item}</li>
                      ))}
                  </ul>}
              </div>
              {!index === length-1 ? <hr /> : null}
          </>
          
      )
}

export default FaqAccordion
